import { isWithinInterval } from 'date-fns';
import { toZonedTime } from 'date-fns-tz';

import { PJM_TZ } from '../index';

export function isDateInSeasonRange(seasonId: string, date: Date): boolean {
    const [seasonStr, yearStr] = seasonId.split('-');
    const year = Number(yearStr);

    // Winter-N: 01 Nov (N-2) - 30 Apr (N-1)
    const start = toZonedTime(new Date(`${year - 2}-11-01T00:00:00`), PJM_TZ);
    const end = toZonedTime(new Date(`${year - 1}-04-30T23:59:59.999`), PJM_TZ);

    return isWithinInterval(date, { start, end });
}
